import React, { useCallback, useEffect, useRef, useState } from "react";
import { s3baseUri } from "../../../../config/config";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import { getReadingTime } from "../../../../utils/Constant";
import { useNavigate, useParams } from "react-router-dom";
import { get_blogs_listing } from "../../../../DAL/blogs/BlogList";
import { enqueueSnackbar } from "notistack";
import RecordNotFound from "../../../../components/recordNotFound/RecordNotFound";
import CircularLoader from "../../../../components/loader/CircularLoader";
import GeneralMUIDialog from "../../../../components/GeneralMUIDialog/GeneralMUIDialog";
import TopBar from "../components/TopBar";
import { useIds } from "../../../../hook/AdminContext";
import AppliedFilters from "../../../../components/AppliedFilters/AppliedFilters";
import { get_podcasts_listing } from "../../../../DAL/podcast/podcast";
import InsightsFilter from "../Insights/components/InsightsFilter";
import InsightCard from "../Insights/components/InsightCard";
import { CircularProgress } from "@mui/material";
import Pagination from "../../../../components/Pagination/Pagination";
import CommingSoon from "../../../../components/recordNotFound/CommingSoon";

export default function PodcastPage({
  searchText = "",
  filterModal,
  contentData = null,
  setFilterModal,
}) {
  const { feature_slug, source_slug } = useParams();
  const navigate = useNavigate();
  const { userInfo, handleGetSectorAccessValue } = useIds();
  const [filterData, setFilterData] = useState({
    category: null,
    list: "all",
  });
  const [appliedFilterData, setAppliedFilterData] = useState(null);
  const [filterChange, setFilterChange] = useState(false);

  const [loading, setLoading] = useState(true);
  const [podcastsListing, setPodcastsListing] = useState([]);

  // load more functionality
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          handleLoadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleLoadMore = () => {
    setIsLoadingMore(true);
    setPageNumber(pageNumber + 1);
    handleGetPodcastsList(pageNumber + 1, true);
  };

  const handleInsightClick = (podcast) => {
    navigate(
      `/${source_slug}/feature/${feature_slug}/podcast-details/${podcast.slug}`,
      {
        state: { blog: podcast, tab: "podcasts" },
      }
    );
  };

  const handleGetPodcastsList = async (page = 0, loadingMore = false) => {
    if (!loadingMore) {
      setLoading(true);
    }
    const resp = await get_podcasts_listing(
      source_slug,
      feature_slug,
      searchText,
      filterData?.category?.title_slug,
      page,
      limit
    );
    if (resp.code == 200) {
      if (loadingMore) {
        setPodcastsListing([...podcastsListing, ...resp.podcast_blog]);
      } else {
        setPodcastsListing(resp.podcast_blog);
      }
      setAppliedFilterData(filterData);
      setPageNumber(page);
      setTotalPages(resp.total_pages);
      setTotalCount(resp.total_podcast_blogs);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setIsLoadingMore(false);
    setLoading(false);
  };

  const handleFilterData = () => {
    setFilterModal(false);
    handleGetPodcastsList();
  };
  useEffect(() => {
    handleGetPodcastsList();
  }, [searchText, filterChange]);

  return (
    <>
      {filterModal && (
        <GeneralMUIDialog
          open={filterModal}
          setOpen={setFilterModal}
          title="Filter"
          actionText="Filter"
          content={
            <InsightsFilter inputs={filterData} setInputs={setFilterData} />
          }
          onSubmit={handleFilterData}
        />
      )}
      <div className="overview-coaches my-3" id="podcasts-container">
        <div className="d-flex justify-content-between align-items-start flex-column flex-md-row flex-nowrap">
          <h6 className="tw-mb-3">Podcasts</h6>
        </div>

        {appliedFilterData && (
          <div>
            <AppliedFilters
              filterData={appliedFilterData}
              setFilterData={setFilterData}
              onFilterChange={() => {
                setFilterChange(!filterChange);
              }}
            />
          </div>
        )}

        {loading ? (
          <CircularLoader />
        ) : (
          <div className="tw-grid tw-grid-cols-1 tw-gap-3">
            {podcastsListing.length > 0 ? (
              <>
                {podcastsListing.map((post) => (
                  <InsightCard
                    post={post}
                    isPodcastCard={true}
                    handleOpenEditCoach={() => {}}
                    handleGetInsightListing={handleGetPodcastsList}
                    handleInsightClick={handleInsightClick}
                  />
                ))}

                <Pagination
                  currentPage={pageNumber}
                  totalCount={totalCount}
                  pageSize={limit}
                  fetchData={(page) => handleGetPodcastsList(page)}
                  loading={isLoadingMore}
                  paginationFor={"podcasts"}
                  conatinerId={"podcasts-container"}
                />
              </>
            ) : (
              <div className="text-center">
                {/* <img
                src="/img/not-found.png"
                alt="No Image Available"
                className="empty-img"
              />
              <h3>Sorry! No podcasts matching your search.</h3>
              <p>Try different category or keywords.</p> */}
                {feature_slug == "leaders-in-the-industry" ? (
                  <CommingSoon />
                ) : (
                  <RecordNotFound title="No Insights" />
                )}
              </div>
            )}

            {/* {!loading &&
              totalPages > 1 &&
              totalPages > pageNumber &&
              podcastsListing.length > 0 && (
                <div className="col-12 text-center mt-3">
                  <div
                    ref={lastBookElementRef}
                    className="mt-3"
                    onClick={() => {
                      handleLoadMore();
                    }}
                    id="load-more-feed"
                  >
                    {isLoadingMore ? (
                      <CircularProgress size={15} />
                    ) : (
                      "Load More"
                    )}
                  </div>
                </div>
              )} */}
          </div>
        )}
      </div>
    </>
  );
}
